import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { LoadScrollService } from 'dmmp-services'

@Component({
  selector: 'dmmp-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss']

})
export class MobileComponent implements OnInit {

  @Input() data
  cards = []
  @Input() itemByRow
  @Output() page = new EventEmitter()

  constructor(
    private loadScroll: LoadScrollService
  ) {
  }

  ngOnInit(): void {
    this.scrollEvent()
  }

  scrollEvent() {
    this.loadScroll.loadScroll(this.data.content, this.itemByRow, this.cards)
  }

}
